export type CanxUser = ReturnType<typeof useAuth>['data']['value']

export enum TransactionTypeEnum {
  BUY = 'buy',
  SELL = 'sell',
  SAMPLE = 'sample',
}
